import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-delete-grid-row-renderer',
  templateUrl: './action-items-grid-row-renderer.component.html',
  styleUrls: ['./action-items-grid-row-renderer.component.scss']
})
export class ActionItemsGridRowRendererComponent implements ICellRendererAngularComp {

  public params: any;
  public deleteRequired;

  agInit(params: any): void {
    this.params = params;
    this.deleteRequired = params.deleteRequired
  }
  constructor() { }
  refresh(): boolean {
    return true;
  }

  performAction($event) {
    if (this.params.onClick instanceof Function) {
      const paramsAndEvent = {
        event: $event,
        action: $event.currentTarget.value,
        params: this.params
      }
      this.params.onClick(paramsAndEvent);
    }
  }

}
